import { render, staticRenderFns } from "./AgentsVacations.vue?vue&type=template&id=d5fb1b38&"
import script from "./AgentsVacations.vue?vue&type=script&lang=js&"
export * from "./AgentsVacations.vue?vue&type=script&lang=js&"
import style0 from "./AgentsVacations.vue?vue&type=style&index=0&id=d5fb1b38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports